<template>
<body class="class-1">
    <div class="d-flex flex-column" id="settings">
        <AppHeader title="Settings" />
        
        <div class="settings_body d-flex flex-column">
            <div class="d-flex flex-column">
                <div class="homerow d-flex flex-column">
                    <div class="txthead d-flex flex-row">
                        System Settings
                    </div>
                    <div class="settings-row d-flex flex-row flex-wrap">
                        <!-- Theme Settings -->
                        <div style="background-color: #5B8C5A;" class="settings-card d-flex flex-column justify-content-center align-items-center" 
                             @click="navigateTo('colorchange')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="3"></circle>
                                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                            </svg>
                            <div class="txt">Theme</div>
                        </div>

                        <!-- Printers Settings -->
                        <div style="background-color: #E3655B" class="settings-card d-flex flex-column justify-content-center align-items-center" 
                             @click="navigateTo('printers')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="6 9 6 2 18 2 18 9"></polyline>
                                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                                <rect x="6" y="14" width="12" height="8"></rect>
                            </svg>
                            <div class="txt">Printers</div>
                        </div>

                        <!-- POS Settings -->
                        <div style="background-color: rgb(56 152 140);" class="settings-card d-flex flex-column justify-content-center align-items-center" 
                             @click="navigateTo('pos_settings')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                                <line x1="8" y1="10" x2="16" y2="10"></line>
                                <line x1="8" y1="14" x2="12" y2="14"></line>
                            </svg>
                            <div class="txt">POS Settings</div>
                        </div>

                        <!-- Floors Settings -->
                        <div style="background-color: #E8BF58;" class="settings-card d-flex flex-column justify-content-center align-items-center" 
                             @click="navigateTo('floors')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
                                <line x1="8" y1="6" x2="16" y2="6"></line>
                                <line x1="8" y1="10" x2="16" y2="10"></line>
                                <line x1="8" y1="14" x2="16" y2="14"></line>
                                <line x1="8" y1="18" x2="12" y2="18"></line>
                            </svg>
                            <div class="txt">Floors</div>
                        </div>
                         <div style="background-color: #52414C;" class="settings-card d-flex flex-column justify-content-center align-items-center" 
                             @click="navigateTo('shifts')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
                                <line x1="8" y1="6" x2="16" y2="6"></line>
                                <line x1="8" y1="10" x2="16" y2="10"></line>
                                <line x1="8" y1="14" x2="16" y2="14"></line>
                                <line x1="8" y1="18" x2="12" y2="18"></line>
                            </svg>
                            <div class="txt">Shifts</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>
</template>

<style scoped>
.class-1 {
    font-family: 'Poppins', sans-serif;
    min-height: 100vh;
    background-color: #f5f5f5;
}

#settings {
    padding: 20px;
}

.settings_body {
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
}

.homerow {
    margin-top: 30px;
}

.txthead {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    padding-left: 10px;
    border-left: 4px solid #4caf50;
}

.settings-row {
    gap: 20px;
    justify-content: flex-start;
}

.settings-card {
    width: 150px;
    height: 150px;
    background: #3B427C;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 20px;
}

.settings-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
    background-color: #f8f9fa;
}

.settings-card svg {
    width: 52px;
    height: 52px;
    stroke: #4caf50;
    margin-bottom: 10px;
    transition: stroke 0.3s ease;
}

.settings-card:hover svg {
    stroke: #45a049;
}

.settings-card .txt {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
}

/* Responsive Design */
@media (max-width: 768px) {
    .settings-row {
        justify-content: center;
    }
    
    .settings-card {
        width: 130px;
        height: 130px;
    }
    
    .settings-card svg {
        width: 40px;
        height: 40px;
    }
}

@media (max-width: 480px) {
    .settings-card {
        width: 100px;
        height: 100px;
        padding: 15px;
    }
    
    .settings-card svg {
        width: 35px;
        height: 35px;
    }
    
    .settings-card .txt {
        font-size: 12px;
    }
}
</style>

<script>
export default {
    name: 'SettingsComponent',
    data() {
        return {
            currentDate: '',
            currentTime: ''
        };
    },
    mounted() {
        this.updateDateTime();
        this.startDateTimeUpdate();
    },
    methods: {
        navigateTo(path) {
            // Check permissions based on the path
            
          this.$router.push('/' + path);
        },
        updateDateTime() {
            const now = new Date();
            this.currentDate = now.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
            this.currentTime = now.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
        },
        startDateTimeUpdate() {
            setInterval(() => {
                this.updateDateTime();
            }, 1000);
        }
    }
};
</script>